// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__XKFEr","buttons":"PendingPaymentAlert_buttons__2Jozv"};